import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzsyaapex7: FaireProductEntity = {
  token: "p_zzsyaapex7",
  type: "product",
  name: 'Minnesota Twins 12" Baseball Shaped Sign',
  brandName: "Fan Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/bd1ab55c6d8b16af829ded8922a64638a850f537f4244a0b1b6f454f1d28da8b.jpeg",
  priceDollars: 7.6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/62f196ae1345411cd1babb6b9161d64ac1c0323e6fa9b192f566663a855b3e67.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
